import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check, ChevronRight, FileText } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader, PageHeader, ProgressBar } from "@/components/common";

export default function Journey() {
  const { t } = useAuth();
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get("/journey").then((r) => setD(r.data)).catch(() => setErr(true)); }, []);
  if (err) return <NoBizCta />;
  if (!d) return <Loader />;
  const cur = d.current_stage?.key;
  return (
    <div>
      <PageHeader eyebrow={t("Journey")} title="From idea to launch, one stage at a time" subtitle={`${d.overall}% of your business journey completed`} />
      <ol className="relative space-y-3 stagger" data-testid="journey-stages">
        {d.stages.map((s) => (
          <li key={s.key}>
            <Link to={`/stage/${encodeURIComponent(s.key)}`} data-testid={`journey-stage-${s.key.replace(" ", "-")}`}
              className={`sb-card p-5 flex items-center gap-4 hover:shadow-md transition-shadow ${s.key === cur ? "ring-2 ring-[#1DB99A]" : ""}`}>
              <span className={`h-12 w-12 shrink-0 rounded-2xl flex items-center justify-center font-display font-extrabold ${s.complete ? "bg-[#1DB99A] text-white" : s.key === cur ? "bg-[#1E2B3C] text-white" : "bg-[#F5F0E6] text-[#8C9BA5]"}`}>
                {s.complete ? <Check className="h-6 w-6" strokeWidth={3} /> : s.order}</span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2"><span className="font-display font-extrabold text-lg">{s.name}</span>{s.key === cur && <span className="sb-chip bg-[#E8F8F4] text-[#179B80]">Current</span>}</div>
                <div className="text-xs text-[#5C6B73] truncate">{s.question}</div>
                <div className="flex items-center gap-3 mt-2"><ProgressBar value={s.pct} className="flex-1" /><span className="text-xs font-bold w-9 text-right">{s.pct}%</span></div>
                <div className="flex gap-3 mt-1.5 text-[11px] text-[#8C9BA5]"><span>{s.lessons_done}/{s.lessons_total} lessons</span><span className="flex items-center gap-1"><FileText className="h-3 w-3" />{s.output}</span></div>
              </div>
              <ChevronRight className="h-5 w-5 text-[#8C9BA5]" />
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
}

export function NoBizCta() {
  return (
    <div className="sb-card p-8 text-center max-w-lg mx-auto mt-6" data-testid="no-business-cta">
      <h2 className="text-xl font-bold">Choose an idea to start your journey</h2>
      <p className="text-sm text-[#5C6B73] mt-2">Pick a business idea and tap “Build this business” to create your workspace.</p>
      <Link to="/ideas" className="sb-btn-primary mt-6 w-full" data-testid="no-business-ideas-btn">Browse ideas</Link>
    </div>
  );
}
